import { type IFramework } from '@/framework';
import { type ILayerProps, type IVectorEffectReflection } from '@/version-types';
import { BaseEffect, type IBaseEffect } from './internal/base-effect';

export interface IReflectionEffect {
    /**
     * 添加倒影
     * @param layerID - 图层 id
     * @param reflection - 倒影配置
     * @returns
     */
    addReflection(layerID: string, reflection: IVectorEffectReflection): ILayerProps | void;

    /**
     * 移除倒影
     * @param layerID - 图层 id
     * @returns
     */
    removeReflection(layerID: string): ILayerProps | void;

    /**
     * 设置倒影可见性
     * @param layerID - 图层 id
     * @param flag - 可见性
     * @returns
     */
    setReflectionVisibility(layerID: string, flag: boolean): ILayerProps | void;

    /**
     * 更新倒影属性
     * @param layerID - 图层 id
     * @param props - 属性
     * @param options - 是否写入历史
     * @returns
     */
    adjustReflectionProps(
        layerID: string,
        props: Partial<IVectorEffectReflection>,
        options?: { writeHistory: boolean },
    ): ILayerProps | void;
}

export class ReflectionEffect implements IReflectionEffect {
    private baseEffect: IBaseEffect;

    constructor(framework: IFramework) {
        this.baseEffect = new BaseEffect(framework);
    }

    addReflection(layerID: string, reflection: IVectorEffectReflection) {
        return this.baseEffect.add(layerID, { kind: 'reflection', config: reflection });
    }

    removeReflection(layerID: string) {
        return this.baseEffect.remove(layerID, 'reflection');
    }

    setReflectionVisibility(layerID: string, flag: boolean) {
        return this.baseEffect.setVisibility(layerID, 'reflection', flag);
    }

    adjustReflectionProps(layerID: string, props: Partial<IVectorEffectReflection>, options = { writeHistory: true }) {
        return this.baseEffect.adjustEffectProps(layerID, 'reflection', props, options);
    }
}
